import { Skeleton } from '@chakra-ui/react';

export default function ChatMeterSkeleton() {
  return <Skeleton w="100%" />;
}
